<template>
  <div class="avatar-list">
    <div
        v-for="user in users"
        :key="`user-${user.name}`"
        style="width: 35px; height: 35px; position: relative"
    >
      <img
          :src="user.avatar"
          class="img-circle m-right-5"
          data-toggle="tooltip"
          data-placement="top"
          :alt="user.name"
          :title="user.name"
      >
      <span
        :class="{
          'label-success': user.online,
          'label-warning': !user.online,
        }"
        class="label"
        style="display: block; width: 10px; height: 13px; border-radius: 100px; position: absolute; top: 0; right: 0"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppAvatarList",

  props: {
    users: {
      type: Array,
      default: [],
    }
  },
}
</script>

<style scoped>
  .avatar-list div {
    width: 35px;
    height: 35px;
    position: relative;
    display: inline-block;
    margin-right: 7px;
  }

  .avatar-list div img {
    width: 35px;
    height: 35px;
    background-image: url(/images/avatar.png);
    background-size: contain;
    text-indent: -9999px;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/AppAvatarList.vue